<template>
  <div class="white-glove-delivery">
    <div v-if="bigTicketDeliveryMethods && bigTicketDeliveryMethods.length">
      <p>
        Please note: Not all delivery methods are available for all furniture items.
        Delivery method will be selected in your bag, and delivery date will be scheduled at checkout.
      </p>

      <div
        v-for="item in bigTicketDeliveryMethods"
        :key="item.name"
      >
        <p class="bold">
          {{ item.name }}
        </p>
        <div
          v-if="item.detailedDescription"
          class="text-justify"
        >
          <ul
            v-for="paragraph in item.detailedDescription.paragraphDetails"
            :key="paragraph"
          >
            <li>{{ paragraph }}</li>
          </ul>
        </div>
      </div>

      <div>Have a question? Call one of our furniture and mattress experts at 1-866-593-2540, 8AM–Midnight EST, 7 days/week.</div>
    </div>
    <ul
      v-else
      class="margin-left-xs"
    >
      <li>Your furniture will be set up and placed where you want it.</li>
      <li>Surcharges apply.</li>
      <li>
        Have a question? Call one of our furniture and mattress experts at 1-866-593-2540, 8AM–Midnight EST, 7
        days/week.
      </li>
      <li>
        <a
          :href="computedShippingUrl"
          target="_blank"
          class="link-body"
        >Delivery Prices</a>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { customerServiceUrls } from 'config';
import { useFeatureEligibility } from '@modules/featureControl';
import { useCommonProductGetters } from '@composables/useCommonProductGetters';

const { bigTicketDeliveryMethods } = useCommonProductGetters();
const { shipping } = customerServiceUrls;
const { isInternationalMode } = useFeatureEligibility();
const computedShippingUrl = isInternationalMode ? shipping.international : shipping.domestic;
</script>

<style lang="scss" scoped>
.white-glove-delivery {
  .bold {
    font-weight: $global-weight-bold;
  }
  .text-justify {
    text-align: justify;
  }
}
</style>
